import {
  BaseDashboardViewState,
  INITIAL_DASHBOARD_VIEW_STATE,
  INITIAL_SETTINGS_OVERRIDES_VIEW_STATE,
  SettingsOverridesState,
} from '../documents.state';

export interface SentDocumentsState {
  dashboardView: BaseDashboardViewState & SettingsOverridesState;
}

export const INITIAL_SENT_DOCUMENTS_STATE: SentDocumentsState = {
  dashboardView: {
    ...INITIAL_DASHBOARD_VIEW_STATE,
    searchParams: {
      ...INITIAL_DASHBOARD_VIEW_STATE.searchParams,
      defaultDateRange: true,
      statuses: ['completed'],
      sortBy: 'authored_on',
      sortDirection: 'desc',
      includeIntegration: true,
      includeConnectors: true,
      includeDeliveryStatuses: true,
    },
    settingsOverrides: INITIAL_SETTINGS_OVERRIDES_VIEW_STATE,
  },
};
